import { useTranslation } from 'react-i18next'

import { Icon, Tooltip } from 'components'

import Button, { ButtonIconProps, ButtonVariant } from '../Buttons/Button'
import { BulkOperationPanelContainer, SelectIconContainer, SelectionLabel } from './styles'

export type BulkOperationAction = {
  disabled?: boolean
  label: string
  onClick: () => void
  variant?: ButtonVariant
  tooltipText?: string
} & ButtonIconProps

export type BulkOperationPanelProps = {
  actions?: BulkOperationAction[]
  selectionLabel?: string
}

const BulkOperationPanel = ({
  actions = [],
  selectionLabel = '',
  selectedRowsCount,
  toggleAllRowsSelected,
  toggleAllPageRowsSelected,
  getToggleAllPageRowsSelectedProps,
  onClearRows,
}: BulkOperationPanelProps & {
  selectedRowsCount: number
  toggleAllRowsSelected: (value: boolean) => void
  toggleAllPageRowsSelected: (value: boolean) => void
  getToggleAllPageRowsSelectedProps: () => { checked?: boolean; indeterminate?: boolean }
  onClearRows?: () => void
  totalRowsCount: number
}) => {
  const { t } = useTranslation()

  const { checked, indeterminate } = getToggleAllPageRowsSelectedProps()

  const handleChangeSelection = () => {
    if (checked || indeterminate) {
      toggleAllPageRowsSelected(false)
      return
    }
    toggleAllPageRowsSelected(true)
  }

  const buttonList = actions.map((a, index) => {
    const buttonProps = {
      disabled: a.disabled,
      marginX: '4px',
      onClick: a.onClick,
      variant: a.variant || 'outline',
      icon: a.icon,
      iconColor: a.iconColor,
      iconPosition: a.iconPosition,
    }

    if (a.tooltipText) {
      return (
        <Tooltip key={index} title={a.tooltipText}>
          <Button {...buttonProps}>{a.label}</Button>
        </Tooltip>
      )
    }

    return (
      <Button key={index} {...buttonProps}>
        {a.label}
      </Button>
    )
  })

  return (
    <BulkOperationPanelContainer>
      <SelectIconContainer
        onClick={() => {
          handleChangeSelection()
        }}
      >
        <Icon fontSize={18} icon={checked ? 'check-square' : indeterminate ? 'minus-square' : ['far', 'square']} />
      </SelectIconContainer>
      <SelectionLabel>
        {selectedRowsCount} {t(selectionLabel)}
      </SelectionLabel>
      {buttonList}
      <Button
        onClick={() => {
          toggleAllRowsSelected(false)
          onClearRows?.()
        }}
        variant="ghost"
      >
        clear_btn
      </Button>
    </BulkOperationPanelContainer>
  )
}

export default BulkOperationPanel
